// authUtils.js
import { b2cPolicies } from "./AuthConfig";


export const getAccessToken = async (context) => {
    const accessTokenRequest = { scopes: b2cPolicies.scopes, account: context.accounts[0] };
    try {
        const accessTokenResponse = await context.instance.acquireTokenSilent(accessTokenRequest);
        storeAccessToken(accessTokenResponse.accessToken);
    } catch (e) {
        clearStorageAndLogout(context);
    }
};

export const storeAccessToken = (token) => {
    localStorage.setItem("accessToken", token);
};

export const clearStorageAndLogout = (context) => {
    localStorage.clear();
    context.instance.logoutRedirect();
};

export const selectOrganization = (organizations, user) => {
    let localOrg = organizations.find(org => org.orgName === localStorage.getItem("selectedOrganization"));
    let cachedOrg = organizations.find(org => org.orgName === user.lastOrganizationAccessed);
    let invitedOrg = organizations.find(org => org._id === localStorage.getItem("selectedOrganizationId"));
    localStorage.removeItem("selectedOrganizationId");
    return invitedOrg || localOrg || cachedOrg || organizations[0];
};

export const redirectToWorkspace = (organizationUrl) => {
    const redirectUrl = localStorage.getItem("redirectUrl");
    let url = process.env.REACT_APP_RUNTIME_URL;

    if (redirectUrl) {
        organizationUrl = redirectUrl;
        localStorage.removeItem("redirectUrl");
    }

    url += organizationUrl ? `/${organizationUrl}` : "";
    window.open(url, "_self");
};

export const redirectToRuntimeAppUrl = (appUrl) => {
    const url = process.env.REACT_APP_RUNTIME_URL + "/" + appUrl;
    console.log("redirectToRuntimeAppUrl", url);
    window.open(url, "_self");
};
